import { render, staticRenderFns } from "./PetStatistics.vue?vue&type=template&id=7d88e422&scoped=true"
import script from "./PetStatistics.vue?vue&type=script&lang=js"
export * from "./PetStatistics.vue?vue&type=script&lang=js"
import style0 from "./PetStatistics.vue?vue&type=style&index=0&id=7d88e422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d88e422",
  null
  
)

export default component.exports